import { Theme } from '@mui/material';

export default {
  components: {
    styleOverrides: {
      root: ({ theme }: { theme: Theme }) => ({
        borderBottom: `1px dashed ${theme.palette.grayBackground.main}`
      })
    }
  }
};
